import { useState, useEffect } from "react";
import { Row, Col } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { baseFilterOrders } from "./orders_delivery_constants";
import classes from "../purchase.module.scss";

import { hasPermission } from "@/services/Utils";
import { useOrderDeliveryPaginate } from "@/hooks/purchases/orders_delivery";

import Head from "@/components/Content/Head";
import Fetching from "@/components/Fetching/Fetching";
import ButtonFilter from "@/components/Filter/ButtonFilter";
import BasePagination from "@/components/Pagination/BasePagination";
import ProductPending from "@/components/Product/ProductPending/ProductPending";

import OrdersDeliveryAction from "./Table/Action/OrdersDeliveryAction";
import OrdersDeliveryActionSelect from "./Table/Action/OrdersDeliveryActionSelect";
import OrdersDeliveryTable from "./Table/OrdersDeliveryTable";
import OrdersDeliveryFilter from "./OrdersDeliveryFilter";
import IntegrationLoad from "../Integration/IntegrationLoad";

const OrdersDelivery = () => {
	const location = useLocation();
	const { filter } = useSelector((state) => state.auth);
	const { estate_parent_id, estate_id, type_currency, search, parameter } = filter;

	const [data, setData] = useState([]);
	const [base, setBase] = useState({
		...baseFilterOrders,
		estate_parent_id,
		estate_id,
		type_currency,
		search,
		parameter,
		location: location.pathname,
	});
	const [showFilter, setShowFilter] = useState(false);
	const [integrationSelect, setIntegrationSelect] = useState({
		show: false,
		name: "",
		integration: "",
	});

	const { data: response, isLoading: loading, isFetching } = useOrderDeliveryPaginate(base);

	const { list, titles, permissions } = response ?? {};
	const { last_page, total, from, to } = list ?? {};

	useEffect(() => {
		if (list) {
			setData(list.data);
		}
		setBase({ ...base, estate_parent_id, estate_id, type_currency, search, parameter });
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [list, estate_parent_id, estate_id, search, parameter, type_currency]);

	useEffect(() => {
		setBase((prev) => ({ ...prev, location: location.pathname }));
	}, [location.pathname]);

	const setPage = (value) => setBase({ ...base, page: value });
	const setPaginate = (value) => setBase({ ...base, paginate: value });

	const applyFilter = (params) => {
		let newBase = { ...base };

		if (params.purchaseOrderDeliveryFilter !== base.purchaseOrderDeliveryFilter) {
			newBase = {
				...newBase,
				purchaseOrderDeliveryFilter: params.purchaseOrderDeliveryFilter,
			};
		}

		if (params.defaultUnitFilter !== base.defaultUnitFilter) {
			newBase = {
				...newBase,
				defaultUnitFilter: params.defaultUnitFilter,
			};
		}

		if (params.purchaseClassFilter !== base.purchaseClassFilter) {
			newBase = {
				...newBase,
				purchaseClassFilter: params.purchaseClassFilter,
			};
		}

		if (params.purchaseStateFilter !== base.purchaseStateFilter) {
			newBase = {
				...newBase,
				purchaseStateFilter: params.purchaseStateFilter,
			};
		}

		if (params.dateFilter !== base.dateFilter) {
			newBase = {
				...newBase,
				dateFilter: params.dateFilter,
			};
		}

		if (params.dateToFilter !== base.dateToFilter) {
			newBase = {
				...newBase,
				dateToFilter: params.dateToFilter,
			};
		}

		if (params.showEmptyFilter !== base.showEmptyFilter) {
			newBase = {
				...newBase,
				showEmptyFilter: params.showEmptyFilter,
			};
		}

		if (params.typeMovement !== base.typeMovement) {
			newBase = {
				...newBase,
				typeMovement: params.typeMovement,
			};
		}

		setBase(newBase);
		setShowFilter(false);
	};

	if (loading) {
		return <Fetching />;
	}

	return (
		<>
			<Head title={"Compras"} titles={titles} isFetching={isFetching} />

			<ButtonFilter origin="main" size_md={12} showFilter={showFilter} setShowFilter={setShowFilter} />

			<ProductPending />

			<Row className={classes.purchase_global}>
				{showFilter && <OrdersDeliveryFilter applyFilter={applyFilter} filters={base} />}
				<Col md={showFilter ? 10 : 12} className={classes.purchase_content}>
					<OrdersDeliveryAction showFilter={showFilter} setShowFilter={setShowFilter} filters={base} setIntegrationSelect={setIntegrationSelect} />

					{data && data.some((d) => d.selected) && <OrdersDeliveryActionSelect />}

					{hasPermission("show", permissions) && <OrdersDeliveryTable data={data} setData={setData} base={base} setBase={setBase} />}

					<BasePagination
						page={base.page}
						paginate={base.paginate}
						last_page={last_page}
						quantity={total}
						from={from}
						to={to}
						setPage={setPage}
						setPaginate={setPaginate}
					/>
				</Col>
			</Row>

			<IntegrationLoad integrationSelect={integrationSelect} />
		</>
	);
};

export default OrdersDelivery;
